import FactItemHtmlFragment from './FactItemHtmlFragment';
export default FactItemHtmlFragment;
export * from './FactItemHtmlFragment.styles';
